import React from 'react';
import { Box } from 'theme-ui';
import {
  GiBoatFishing,
  GiFamilyHouse,
  GiFishing,
  GiFishingPole,
} from 'react-icons/gi';
import { AiOutlineControl, AiOutlineCloseCircle } from 'react-icons/ai';
import { GoPrimitiveDot } from 'react-icons/go';
import { GrLocation } from 'react-icons/gr';
import { IoMdImages } from 'react-icons/io';

const iconMap = {
  boatfish: GiBoatFishing,
  house: GiFamilyHouse,
  fish: GiFishing,
  fishrod: GiFishingPole,
  filter: AiOutlineControl,
  close: AiOutlineCloseCircle,
  dot: GoPrimitiveDot,
  location: GrLocation,
  gallery: IoMdImages,
};
const sizes = {
  xsmall: {
    width: ['1.0em', '1.2em'],
  },
  small: {
    width: ['1.2em', '1.5em'],
  },
  medium: {
    width: ['1.6em', '1.8em'],
  },
  large: {
    width: ['2.1em', '2.1em'],
  },
  xlarge: {
    width: ['2.1em', '2.5em'],
  },
};
function Icon({ icon, nudge, onClick, sx, size = 'medium' }) {
  const IconComponent = iconMap[icon] || null;
  return (
    <Box onClick={onClick} sx={{ ...sizes[size], ...sx }}>
      <IconComponent
        style={{
          marginTop: nudge ? nudge : 'auto',
          verticalAlign: 'middle',
          width: '100%',
          height: '100%',
        }}
      />
    </Box>
  );
}

export default Icon;
